// Dashboard card → permission key. Admins toggle these per role in
// Settings → System → Roles & Permissions → Dashboard.
export const WIDGET_PERM = {
  statCards: 'dash_stat_cards',
  pieChart: 'dash_requests_overview',
  systemOverview: 'dash_system_overview',
  upcomingMatches: 'dash_upcoming_matches',
  upcomingRoundRequests: 'dash_round_requests',
  recentRequests: 'dash_recent_requests',
  rightsBalances: 'dash_rights_balances',
  barChart: 'dash_rights_usage',
};
